import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const AlternateBroadcast = styled.div`
    color: ${({ theme }) => theme.Text.secondary};

    ${BaseStyle.Mixins.fontStyles.ui['14m']}

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['16m']}
        padding-top: 8px;
    }

    b {
        color: ${({ theme }) => theme.Text.primary};
        ${BaseStyle.Mixins.fontStyles.ui['14b']}

        ${BaseStyle.Mixins.screenSizes.large} {
            ${BaseStyle.Mixins.fontStyles.ui['16b']}
        }
    }
`;
